const findGCD = (a, b) => {
    while (b !== 0) {
        [a, b] = [b, a % b]; // Swap values using destructuring
    }
    return a;
};
// const standardRatios = [
//     { ratio: "16:9", value: 16 / 9 },
//     { ratio: "4:3", value: 4 / 3 },
//     { ratio: "21:9", value: 21 / 9 },
//     { ratio: "3:2", value: 3 / 2 },
//     { ratio: "1:1", value: 1 },
//     { ratio: "5:4", value: 5 / 4 },
// ];
// const aspectRatioOptions = ['1:1','2:1','3:1','3:2','4:1','4:3','5:4','9:16','16:9','21:9'];
const standardRatios = [
    { ratio: "1:1", value: 1 / 1 },
    { ratio: "2:1", value: 2 / 1 },
    { ratio: "3:1", value: 3 / 1 },
    { ratio: "4:1", value: 4 / 1 },
    { ratio: "4:3", value: 4 / 3 },
    { ratio: "9:16", value: 9 / 16 },
    { ratio: "16:9", value: 16 / 9 },
    { ratio: "21:9", value: 21 / 9 },
    { ratio: "3:2", value: 3 / 2 },
    { ratio: "5:4", value: 5 / 4 },

];
const calculateAspectRatio = (width, height) => {
    const w = Number(width);
    const h = Number(height);

    // Validate inputs
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) {
        return "Invalid dimensions";
    }

    // Find GCD and get the simplified ratio
    const gcd = findGCD(w, h);
    const simplifiedWidth = w / gcd;
    const simplifiedHeight = h / gcd;
    const actualRatio = simplifiedWidth / simplifiedHeight;

    // Find the closest standard aspect ratio
    let closestRatio = standardRatios.reduce((prev, curr) => 
        Math.abs(curr.value - actualRatio) < Math.abs(prev.value - actualRatio) ? curr : prev
    );

    return closestRatio.ratio; // Return the closest standard ratio
};
export default calculateAspectRatio;